import VerifyNewEmail from 'features/myVaro/screens/PersonalDetails/ChangeEmail/VerifyNewEmail/VerifyNewEmail';
import React from 'react';

export default function ChangeEmailVerifyScreen() {
  return <VerifyNewEmail />;
}
